function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME, SEMANTIC_ATTRIBUTE_PROFILE_ID } from '../semanticAttributes.js';
import '../utils-hoist/debug-build.js';
import '../utils-hoist/logger.js';
import { dropUndefinedKeys } from '../utils-hoist/object.js';
import '../utils-hoist/time.js';
import '../utils-hoist/syncpromise.js';

/**
 * Converts a transaction event to a span JSON object.
 */
function convertTransactionEventToSpanJson(event) {
  var _event$contexts$trace, _event$contexts, _event$start_timestam;
  var _ref = (_event$contexts$trace = (_event$contexts = event.contexts) === null || _event$contexts === void 0 ? void 0 : _event$contexts.trace) !== null && _event$contexts$trace !== void 0 ? _event$contexts$trace : {},
    trace_id = _ref.trace_id,
    parent_span_id = _ref.parent_span_id,
    span_id = _ref.span_id,
    status = _ref.status,
    origin = _ref.origin,
    data = _ref.data,
    op = _ref.op;
  return dropUndefinedKeys({
    data: data !== null && data !== void 0 ? data : {},
    description: event.transaction,
    op: op,
    parent_span_id: parent_span_id,
    span_id: span_id !== null && span_id !== void 0 ? span_id : '',
    start_timestamp: (_event$start_timestam = event.start_timestamp) !== null && _event$start_timestam !== void 0 ? _event$start_timestam : 0,
    status: status,
    timestamp: event.timestamp,
    trace_id: trace_id !== null && trace_id !== void 0 ? trace_id : '',
    origin: origin,
    profile_id: data === null || data === void 0 ? void 0 : data[SEMANTIC_ATTRIBUTE_PROFILE_ID],
    exclusive_time: data === null || data === void 0 ? void 0 : data[SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
    measurements: event.measurements,
    is_segment: true
  });
}

/**
 * Converts a span JSON object to a transaction event.
 */
function convertSpanJsonToTransactionEvent(span) {
  var event = {
    type: 'transaction',
    timestamp: span.timestamp,
    start_timestamp: span.start_timestamp,
    transaction: span.description,
    contexts: {
      trace: {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        op: span.op,
        status: span.status,
        origin: span.origin,
        data: _objectSpread(_objectSpread(_objectSpread({}, span.data), span.profile_id && _defineProperty({}, SEMANTIC_ATTRIBUTE_PROFILE_ID, span.profile_id)), span.exclusive_time && _defineProperty({}, SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME, span.exclusive_time))
      }
    },
    measurements: span.measurements
  };
  return dropUndefinedKeys(event);
}
export { convertSpanJsonToTransactionEvent, convertTransactionEventToSpanJson };